import { Input } from "@/components/ui/input";

export function Field({ label, children, hint, className = "" }) {
  return (
    <label className={`block ${className}`}>
      <span className="mb-1 block text-xs font-medium uppercase tracking-wider text-slate-500">{label}</span>
      {children}
      {hint && <span className="mt-1 block text-[11px] text-slate-500">{hint}</span>}
    </label>
  );
}

export function TextInput(props) {
  return <Input {...props} className={`border-slate-700 bg-slate-950 text-slate-100 ${props.className || ""}`} />;
}

export function Pill({ children, tone = "slate", testid }) {
  const tones = {
    slate: "border-slate-700 bg-slate-800/60 text-slate-300", green: "border-emerald-500/30 bg-emerald-500/10 text-emerald-300",
    amber: "border-amber-500/30 bg-amber-500/10 text-amber-300", red: "border-red-500/30 bg-red-500/10 text-red-300", cyan: "border-cyan-400/30 bg-cyan-400/10 text-cyan-300",
  };
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${tones[tone]}`} data-testid={testid}>{children}</span>;
}

export function Stat({ icon: Icon, label, value, testid, accent = "text-cyan-300" }) {
  return (
    <div className="glow-card rounded-2xl p-5" data-testid={testid}>
      <div className={`grid h-10 w-10 place-items-center rounded-xl bg-slate-800/70 ${accent}`}><Icon className="h-5 w-5" /></div>
      <p className="mt-3 font-display text-2xl font-extrabold text-white sm:text-3xl">{value}</p>
      <p className="text-sm text-slate-400">{label}</p>
    </div>
  );
}

export const selectCls = "w-full rounded-md border border-slate-700 bg-slate-950 px-3 py-2 text-sm text-slate-100 outline-none focus:border-cyan-400";
export const toLocalInput = (iso) => (iso ? iso.slice(0, 16) : "");
